export default `
.price-labels {
  color: #000;
  background: #fff;
  line-height: normal;
}
.price-labels {
  display: flex;
  flex-wrap: wrap;
}

.price-labels .tag {
  break-inside: avoid;
  flex-shrink: 0;

  width: 4cm;
  height: 2cm;

  border: 1px solid #000;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  font-family: Arial, sans-serif;
}

.price-labels .tag > .owner {
  font-size: 6pt;
  font-weight: 700;
  color: #fff;
  background-color: #000;
  text-align: center;
}

.price-labels .tag > .name {
  padding: 0 2px;
  height: 28px;
  font-size: 7pt;
  font-weight: 600;
  line-height: 1.1;
  flex-grow: 1;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  overflow: hidden;
  text-overflow: ellipsis;
}

.price-labels .tag > .price {
  padding: 0 2px;
  font-size: 12pt;
  font-weight: 700;
  margin: 0.5mm 0;
}

.price-labels .tag > .price > span {
  font-size: 8pt;
}

.price-labels .tag > .barcode-wrapper {
  padding: 0 4px;
  height: 30px;
  display: flex;
  justify-content: center;
}

.price-labels .tag > .barcode-wrapper svg {
  width: 100% !important;
  height: 100%;
}

.price-labels .tag-a4 {
  break-inside: avoid;
  flex-shrink: 0;

  width: 6cm;
  height: 4cm;

  border: 1px solid #000;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  font-family: Arial, sans-serif;
}

.price-labels .tag-a4 > .owner {
  font-size: 8pt;
  font-weight: 700;
  color: #fff;
  background-color: #000;
  text-align: center;
}

.price-labels .tag-a4 > .name {
  padding: 0 2px;
  font-size: 12pt;
  font-weight: 600;

  text-align: center;

  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;

  overflow: hidden;
  text-overflow: ellipsis;
}

.price-labels .tag-a4 > .price {
  border-top: 1px solid #000;
  padding: 0 2px;
  font-size: 46pt;
  font-weight: 800;
  margin: 0.5mm 0;

  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.price-labels .tag-a4 > .price > span {
  font-size: 8pt;
  font-weight: bold;
  text-align: center;
  display: flex;
  align-items: end;
  height: 65%;
}

.price-labels .tag-a4 > .barcode-wrapper {
  padding: 0 4px;
  height: 30px;
  display: flex;
  justify-content: center;
}

.price-labels .tag-a4 > .barcode-wrapper svg {
  width: 100% !important;
  height: 100%;
}

.price-labels .owner {
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
`
